module.exports = __webpack_public_path__ + "img/jiaoyu.51ee39ab.png";